import React from 'react';
import { Card, CircularProgress, Grid, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useCommonStyles } from './styles';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    padding: 24,
    borderRadius: 1,
    background: (props) =>
      theme.palette.matchingDetailsPage[props.mode].textSecondary,
    boxShadow: (props) =>
      props.mode === 'dark'
        ? '0px 0px 16px 0px rgba(28, 28, 28, 0.37)'
        : '0px 0px 16px 0px rgba(230, 230, 230, 0.25)',
    border: (props) => (props.mode === 'dark' ? '1px solid #4C4D61' : 'none'),
  },
  title: {
    paddingBottom: 20,
  },
  progress: {
    color: '#428BFA',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const MatchingDetailsCard = ({
  rootClass = '',
  title = '',
  mode,
  loading = false,
  children,
}) => {
  const classes = useStyles({ mode });
  const commonClasses = useCommonStyles({ mode });

  return (
    <Card
      classes={{
        root: clsx(
          classes.cardContainer,
          rootClass,
          loading ? classes.progress : ''
        ),
      }}
    >
      {title && (
        <Grid container>
          <Grid
            item
            xs={12}
            classes={{
              root: clsx(commonClasses.fontMediumBold, classes.title),
            }}
          >
            {title}
          </Grid>
        </Grid>
      )}
      {loading ? (
        <CircularProgress
          classes={{
            root: clsx(classes.progress),
          }}
        />
      ) : (
        children
      )}
    </Card>
  );
};

export default MatchingDetailsCard;
